import { formatDistanceToNow } from 'date-fns';

import { Badge } from '@/components/badge';
import { ShipmentEtaBadge } from '@/components/modules/shipment/eta-badge';
import { Text } from '@/components/text';
import { ShipmentModel } from '@/lib/models/shipment/types';
import { formatDateForUser } from '@/utils/format';

interface ShipmentArrivingAtProps {
  eta: ShipmentModel['eta'];
  ata: ShipmentModel['ata'];
  originalEta: ShipmentModel['originalEta'];
  delay: ShipmentModel['delay'];
  modeType: ShipmentModel['type'];
  trackingUpdatedAt: ShipmentModel['trackingUpdatedAt'];
  showUpdatedAt?: boolean;
}

const ShipmentArrivingAt = ({
  eta,
  ata,
  originalEta,
  delay,
  modeType,
  trackingUpdatedAt,
  showUpdatedAt = true,
}: ShipmentArrivingAtProps) => {
  if (ata) {
    return (
      <div className="flex items-center gap-1">
        <Badge variant="light">ATA</Badge>
        <span className="text-grey-500">{formatDateForUser(ata)}</span>
      </div>
    );
  }

  return eta ? (
    <div>
      <div className="flex items-center">
        <div className="flex items-center gap-1 font-medium">
          <ShipmentEtaBadge delay={delay} modeType={modeType} eta={eta} originalEta={originalEta} />
          {formatDateForUser(eta)}
        </div>
      </div>
      {trackingUpdatedAt && showUpdatedAt && (
        <Text variant="sm" className="chromatic-ignore m-0 text-xs italic text-grey-500">
          Updated {formatDistanceToNow(new Date(trackingUpdatedAt))} ago
        </Text>
      )}
    </div>
  ) : (
    '-'
  );
};

export { ShipmentArrivingAt };
